import React from 'react';
import {connect} from 'react-redux';

import {addComment, onChangeComment} from './../../../../redux/actions';
import {PrimaryButton, SecondaryButton} from "@sfly/uig-button";
import helpers from './../../../../components/utils/helper'

class AddComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            rows: 1
        }
    }

    addComment = (event) => {
        event.preventDefault();
        if (!this.props.comments.commentText || !(this.props.comments.commentText.replace(/ /g, ''))) {
            return;
        }
        this.props.addComment({
            userId: this.props.user.userId,
            commentText: this.props.comments.commentText,
            family_name: this.props.user.family_name,
            given_name: this.props.user.given_name,
            email: this.props.user.email
        }, this.props.originalSharedProjectGuid);
        this.autoGrow();
    }

    onChange = (evt) => {
        this.props.onChangeComment(evt.target.value);
    }

    autoGrow = () => {
        // this.setState({
        //     autoGrow: false
        // });
        var height = document.getElementById("add-comment-id").scrollHeight;
        var rows = Math.floor(height / 21);
        if (rows > 4) rows = 4;
        console.log('rows', rows);
        if (this.state.rows !== rows && rows > 1) {
            this.setState({
                rows
            })
        }
    }

    onKeyDown = (event) => {
        if (event.which === 13 && !event.shiftKey) {
            event.preventDefault();
            this.addComment(event);
            return;
        }
    }

    showCommentEnable = (commentText) => {
        return commentText && commentText.replace(/ /g, '').length > 0;
    }


    render() {
        return (
            <div className="add-comment-container">
                <form className="add-comment-form" onSubmit={this.addComment}>
                    <div className="add-comment">
                        <textarea
                            rows={this.state.rows}
                            type="text"
                            value={this.props.comments.commentText}
                            onChange={this.onChange}
                            onKeyUp={this.autoGrow}
                            onKeyDown={this.onKeyDown}
                            id="add-comment-id"/>
                    </div>
                    <div>
                        {
                            this.showCommentEnable(this.props.comments.commentText)
                                ?
                                <PrimaryButton onClick={this.addComment}>
                                    {helpers.isMobile ? "POST" : "COMMENT"}
                                </PrimaryButton>
                                :
                                <SecondaryButton onClick={() => {
                                    return;
                                }}>
                                    {helpers.isMobile ? "POST" : "COMMENT"}
                                </SecondaryButton>
                        }


                    </div>
                </form>

            </div>)
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        comments: state.comments
    }
}

const mapDisptachToProps = {
    addComment,
    onChangeComment
}

export default connect(mapStateToProps, mapDisptachToProps)(AddComment);